/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { BlockingTypes } from "../Blocking";

const BlockingContainer = styled.div`
  min-width: 224px;
  max-width: 224px;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #979797;
    text-transform: uppercase;

    margin-bottom: 16px;

    &:not(:first-of-type) {
      margin-top: 16px;
    }
  }

  .button {
    width: 100%;
    height: 50px;
    cursor: pointer;
    padding: 16px;

    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: start;

    transition: background-color 0.3s;

    background-color: #ffffff;

    cursor: pointer;

    transition: background-color 0.3s ease-in-out;

    &:hover {
      background-color: #f9f9f9;
    }

    &.selected {
      background-color: #fff2e5;

      .image-wrapper {
        img {
          filter: grayscale(0);
        }
      }

      &:hover {
        background-color: rgb(251, 151, 46, 0.05);
      }
    }

    .image-wrapper {
      width: 24px;
      height: 24px;

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        filter: grayscale(1);
      }
    }

    .text {
      margin-left: 8px;

      font-size: 16px;
      font-weight: 600;
      color: #2f2f2f;
    }
  }
`;

interface Props {
  selected: BlockingTypes;
  handleSelected: (vle: BlockingTypes | string) => void;
}

export default function BlockingHeader(props: Props) {
  const { selected, handleSelected } = props;

  return (
    <BlockingContainer>
      <div className="title">Contact Block</div>

      <div
        className={`button ${
          selected === BlockingTypes.EMAIL ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.EMAIL)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/Email.svg" alt="Email" />
        </div>
        <div className="text">Email Address</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.PHONE ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.PHONE)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/Phone.svg" alt="Email" />
        </div>
        <div className="text">Phone</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.DEVICE_ID ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.DEVICE_ID)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/DeviceID.svg" alt="Email" />
        </div>
        <div className="text">Device ID</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.DEVICE_IP ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.DEVICE_IP)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/DeviceIP.svg" alt="Email" />
        </div>
        <div className="text">Device IP</div>
      </div>

      <div className="title">Global Blocking</div>

      <div
        className={`button ${
          selected === BlockingTypes.COUNTRIES ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.COUNTRIES)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/Country.svg" alt="Email" />
        </div>
        <div className="text">Country</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.COUNTRY_CODE ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.COUNTRY_CODE)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/CountryCode.svg" alt="Email" />
        </div>
        <div className="text">Country Code</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.DOMAIN ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.DOMAIN)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/Domain.svg" alt="Email" />
        </div>
        <div className="text">Domain</div>
      </div>

      <div
        className={`button ${
          selected === BlockingTypes.KEYWORD ? "selected" : ""
        }`}
        onClick={() => handleSelected(BlockingTypes.KEYWORD)}
      >
        <div className="image-wrapper">
          <img src="/icons/blocking/Keyword.svg" alt="Email" />
        </div>
        <div className="text">Keyword</div>
      </div>
    </BlockingContainer>
  );
}
